module.exports = __webpack_public_path__ + "static/media/rami.cfef1d03.jpg";